import { render } from "./InfiniteScrollPage.vue?vue&type=template&id=2fe91be8&scoped=true"
import script from "./InfiniteScrollPage.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollPage.vue?vue&type=script&lang=js"

import "./InfiniteScrollPage.vue?vue&type=style&index=0&id=2fe91be8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe91be8"]])

export default __exports__